export const UPDATE_CVS = "UPDATE_CVS";

export const updateCVs = (value) => ({
  type: UPDATE_CVS,
  value,
});
